import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const topWorkersResponse = z.array(
  z.object({
    worker_id: z.number(),
    worker_most_recent_position_name: z.string(),
    worker_rating: z.number(),
    shift_count: z.number(),
    worker_name: z.string(),
    worker_profile_pic_url: z.string().nullable(),
  })
)

export type TopWorkers = z.infer<typeof topWorkersResponse>

export async function getTopWorkers(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)
  return api
    .post('/company/pulse/performance/top_workers', data, { signal })
    .then((res) => res.data.top_workers ?? [])
}
